module.exports = __webpack_public_path__ + "static/media/Tupe10.0433012b.webp";